module.exports = __webpack_public_path__ + "img/logo3.bd1ef8a4.png";